import { FunctionComponent, CSSProperties } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom";
import Icon from "@mui/material/Icon"
import Tooltip from "@mui/material/Tooltip"

import {
  AdminCard,
  AdminCardHeader,
  AdminCardButtons,
  AdminButton,
  AdminCardScores,
  ScoreCard,
  ScoreCardText,
  ScoreCardCounter,
} from "./styled.components"

type AdminCardsProps = {
  dataCards: any
}

const AdminCards: FunctionComponent<AdminCardsProps> = ({ dataCards }) => {
  const history = useNavigate();
  const { context } = useSelector((state: any) => state.theme)  

  const styles: CSSProperties = {
    fontSize: `clamp(1.7rem, 2.5vw, 1.5rem)`,
  }

  const handleRenderCardViews = (item: any, index: number) => {
    const { buttons, scores, estilo } = item
    if (estilo) {
      item.estilo = JSON.parse(estilo)
    }
    return (
      <AdminCard
        key={`report-card-${item.id}`}
        bg={context?.backgroundItem}
        textColor={item.style.textColor}>
        <AdminCardHeader>
          <Icon
            style={{
              color: item.style.contentColor,
              fontSize: styles.fontSize,
              paddingTop: "2px"
            }}>
            {item.icon}
          </Icon>
          {item.title}
        </AdminCardHeader>
        <AdminCardButtons>
          {buttons && buttons.map(handleRenderCardViewButtons)}
        </AdminCardButtons>
        <AdminCardScores quantity={scores.length}>
          {scores && scores.map(handleRenderCardViewScores)}
        </AdminCardScores>
      </AdminCard>
    )
  }

  const handleRenderCardViewButtons = (item: any, index: number) => {
    return (
      <AdminButton
        id={item.id}
        key={item.id}        
        textColor={item.style.contentColor}
        onClick={() => {
          history(`/${item.url}`);
        }}>
        {item.text}
      </AdminButton>
    )
  }

  const handleRenderCardViewScores = (item: any, index: number, list: any) => {
    return (
      <ScoreCard id={item.id} key={item.id} quantity={list.length}>
        <Tooltip title={item.text} leaveDelay={400} placement="top">
          <ScoreCardText>{item.text}</ScoreCardText>
        </Tooltip>
        <ScoreCardCounter textColor={item.style.contentColor}>
          {item.value}
        </ScoreCardCounter>
      </ScoreCard>
    )
  }

  return <>{dataCards.map(handleRenderCardViews)}</>
}

export default AdminCards
